import '../../styles/style.css';
import '../../styles/light-mode.css';

import { useTranslation } from "react-i18next"

export default function ProjectCard({
    image,
    title,
    description,
    a,
    div1,
    div2,
    div3,
}) {


    const { t } = useTranslation();

    const renderDiv = (text) => {
        if (!text) return null;
        return <div>{text}</div>;
    };

    return (
        <div data-aos="fade-up" className="project-card">

            <div className='div-project-img'>
                <img src={image} alt={title} className="project-image" />
            </div>

            <div className="project-content">

                <h3>{title}</h3>

                <div className="div-desc">
                    <p>{description}</p>
                </div>

                <div className="component">
                    {renderDiv(div1)}
                    {renderDiv(div2)}
                    {renderDiv(div3)}
                </div>

                <a
                    href={a}
                    target="_blank"
                    rel="noreferrer"
                    className="btn-click"
                >
                    {t("veiw-project.text")}
                </a>

            </div>

        </div>
    );
}